/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IPharmacyExternalOrder } from 'app/shared/model/pharmacy-external-order.model';
import { IClinicalDictionary } from 'app/shared/model/clinical-dictionary.model';
import { SupplierType } from 'app/shared/model/enumerations/supplier-type.model';
import { ConsumerType } from 'app/shared/model/enumerations/consumer-type.model';
import { ShipmentStatus } from 'app/shared/model/enumerations/shipment-status.model';
import { PharmacyAddedByType } from 'app/shared/model/enumerations/pharmacy-added-by-type.model';

export interface IPharmacyExternalOrderShipment {
  id?: string;
  saleBillId?: string | null;
  purchaseBillId?: string | null;
  refundBillId?: string | null;
  active?: boolean;
  cursor?: number;
  lastUpdated?: number;
  microSec?: number;
  timestampEntry?: number;
  supplierId?: string;
  supplierIdType?: keyof typeof SupplierType;
  consumerId?: string;
  consumerType?: keyof typeof ConsumerType;
  shipmentStatus?: keyof typeof ShipmentStatus;
  consignmentNumber?: string | null;
  carrierDetails?: string | null;
  internalShipmentNumber?: string | null;
  addedById?: string | null;
  modifiedById?: string | null;
  addedByType?: keyof typeof PharmacyAddedByType | null;
  modifiedByType?: keyof typeof PharmacyAddedByType | null;
  billNumber?: string | null;
  excludeTax?: boolean | null;
  portCode?: string | null;
  order?: IPharmacyExternalOrder | null;
  exportType?: IClinicalDictionary | null;
}

export const defaultValue: Readonly<IPharmacyExternalOrderShipment> = {
  active: false,
  excludeTax: false,
};
